import Buttons from '@/components/Modules/Table/TableButtons.vue';
import spe from './table_ItemsTJ';

spe.options.actions = Buttons;

export default spe;



// WEBPACK FOOTER //
// ./src/components/Pages/Index/tableItemsT.js